var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDowntime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 13.5C9.25 13.05 8.9 12.75 8.5 12.6V11C11 10.75 13 8.59997 13 6.04997C13 3.49997 10.75 1.04997 8 1.04997C5.25 1.04997 3 3.24997 3 5.99997C3 8.74997 4.95 10.75 7.5 11V12.6C7.05 12.75 6.75 13.1 6.6 13.5H2V14.5H6.6C6.8 15.1 7.35 15.5 8 15.5C8.65 15.5 9.2 15.1 9.4 14.5H14V13.5H9.4ZM4 5.99997C4 3.79997 5.8 1.99997 8 1.99997C10.2 1.99997 12 3.79997 12 5.99997C12 8.19997 10.2 9.99997 8 9.99997C5.8 9.99997 4 8.19997 4 5.99997ZM8 14.5C7.7 14.5 7.5 14.25 7.5 14C7.5 13.75 7.7 13.5 8 13.5C8.3 13.5 8.5 13.75 8.5 14C8.5 14.25 8.25 14.5 8 14.5ZM9.65 8.34997L7.5 6.19997V2.99997H8.5V5.79997L10.35 7.64997L9.65 8.34997Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDowntime);
export default __webpack_public_path__ + "static/media/ic-downtime.f1b5c2fa7c19da5fecf10913f98d18fb.svg";
export { ForwardRef as ReactComponent };